"use client";

/**
 * Tiny client island that fires a PostHog event on mount. Used by
 * server components to instrument funnel-stage views (e.g.,
 * `compass_landing_view`, `pricing_view`) without converting the
 * whole tree to a client component.
 *
 * Mount-time-only — fires exactly once per route, regardless of
 * re-renders. Safe to drop into any server component as
 * `<EventOnMount event="compass_landing_view" />`.
 */

import { useEffect, useRef } from "react";
import { trackEvent } from "@/lib/posthog";

interface EventOnMountProps {
  event: string;
  properties?: Record<string, unknown>;
}

export function EventOnMount({ event, properties }: EventOnMountProps) {
  const fired = useRef(false);
  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    trackEvent(event, properties);
  }, [event, properties]);
  return null;
}
